<template>
  <div>
    <div class="table-ui-detail">
      <table>
        <thead>
          <tr>
            <th width="1%" class="ts-text-center">{{ $t('no') }}</th>
            <th width="7%">{{ $t('promotion.productGroup') }}</th>
            <th width="7%">{{ $t('promotion.barcode') }}</th>
            <th width="10%">{{ $t('promotion.product') }}</th>
            <th width="9%">{{ $t('promotion.sparePartGroup') }}</th>
            <th width="9%">{{ $t('promotion.incentiveProduct') }}</th>
            <th width="8%">{{ $t('promotion.sign') }}</th>
            <th width="8%">{{ $t('promotion.amountFrom') }}</th>
            <th width="8%">{{ $t('promotion.amountTo') }}</th>
            <th width="4%">{{ $t('promotion.discountType') }}</th>
            <th width="8%">{{ $t('promotion.discountRate') }}</th>
            <th width="4%">{{ $t('promotion.incentiveType') }}</th>
            <th width="8%">{{ $t('promotion.incentiveRate') }}</th>
            <th width="8%">{{ $t('promotion.vendorCustomer') }}</th>
            <th width="1%" class="ts-text-center">
              <a href="#" @click.prevent="addItem">
                <i class="fa fa-plus"></i>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="model.condition.length == 0">
            <td colspan="15" class="ts-text-center ts-p-3 ts-space-x-1">
              <i class="fa fa-folder-open ts-text-gray-200"></i>
              <label class="ts-text-gray-400">
                {{ $t('noData') }}
              </label>
            </td>
          </tr>
          <tr v-for="(item, index) in model.condition" :key="index">
            <td class="ts-whitespace-no-wrap ts-text-center" style="max-width: 25px;">
              {{ index + 1 }}
            </td>
            <td class="ts-overflow-hidden ts-whitespace-no-wrap" style="max-width: 90px;">
              {{ getProductGroup(item.pro_group_id) ? getProductGroup(item.pro_group_id).pro_group_name_en :
                'N/A' }}
            </td>
            <td class="ts-overflow-hidden ts-whitespace-no-wrap" style="max-width: 90px;">
              {{ getProduct(item.product_id) ? getProduct(item.product_id).barcode : 'N/A' }}
            </td>
            <td class="ts-overflow-hidden ts-whitespace-no-wrap" style="max-width: 100px;">
              {{ getProduct(item.product_id) ? getProduct(item.product_id).product_name_en : 'N/A' }}
            </td>
            <td class="ts-overflow-hidden ts-whitespace-no-wrap" style="max-width: 130px;">
              <a-select v-model="item.spare_part_group_id" :options="productGroups" show-search mode="multiple"
                :maxTagCount="1" option-filter-prop="children" class="ts-w-full"
                :class="{ 'is-invalid': errors.has('service_status') }" placeholder="Select"></a-select>
            </td>
            <td class="ts-overflow-hidden ts-whitespace-no-wrap" style="max-width: 130px;">
              <a-select v-model="item.incentive_product_id" :options="incentiveProducts" show-search
                option-filter-prop="children" class="ts-w-full" :class="{ 'is-invalid': errors.has('service_status') }"
                placeholder="Select"></a-select>
            </td>
            <td style="max-width: 110px;">
              <a-select v-model="item.operator_sign" class="ts-w-full" style="min-width: 50px"
                @change="operatorChange(item)"
                :class="{ 'is-invalid': errors.has('condition.' + index + '.operator_sign') }">
                <a-select-option value="=">Equal</a-select-option>
                <a-select-option value="between">Between</a-select-option>
                <a-select-option value=">=">Greater or equal</a-select-option>
              </a-select>
            </td>
            <td class="text-center ts-whitespace-no-wrap" style="min-width: 130px;">
              <ts-currency-converter-input :input_amount.sync="item.input_amount_from" :amount.sync="item.amount_from"
                :input_currency_id.sync="item.input_currency_id" :currency_id.sync="item.currency_id"
                :fx_rate.sync="item.fx_rate" :fx_rate_ratio.sync="item.fx_rate_ratio" style="min-width: 60px;"
                :class_name="{ 'is-invalid': errors.has('condition.' + index + '.amount_from') }" />
            </td>
            <td class="text-center ts-whitespace-no-wrap" style="min-width: 130px;">
              <ts-currency-converter-input :input_amount.sync="item.input_amount_to" :amount.sync="item.amount_to"
                :input_currency_id.sync="item.input_currency_id" :currency_id.sync="item.currency_id"
                :fx_rate.sync="item.fx_rate" :fx_rate_ratio.sync="item.fx_rate_ratio" style="min-width: 60px;"
                :disabled="item.operator_sign != 'between'"
                :class_name="{ 'is-invalid': errors.has('condition.' + index + '.amount_to') }" />
            </td>
            <td style="min-width: 80px;">
              <a-select v-model="item.discount_type" class="ts-w-full" style="min-width: 50px"
                @change="onChangeItem(item)">
                <a-select-option value="%">%</a-select-option>
                <a-select-option :value="getDiscountCurrency(item.input_currency_id)">
                  {{ getDiscountCurrency(item.input_currency_id) }}
                </a-select-option>
              </a-select>
            </td>
            <td style="min-width: 130px;">
              <input v-if="item.discount_type == '%'" ref="discountRate" type="number"
                v-model.number="item.input_discount_rate" class="form-control" @change="onChangeItem(item)" />
              <ts-currency-converter-input v-else :input_amount.sync="item.input_discount_rate"
                :amount.sync="item.discount_rate" :input_currency_id.sync="item.input_currency_id"
                :currency_id.sync="item.currency_id" :fx_rate.sync="item.fx_rate"
                :fx_rate_ratio.sync="item.fx_rate_ratio" style="min-width: 120px;" />
            </td>
            <td style="min-width: 80px;">
              <a-select v-model="item.incentive_type" class="ts-w-full" style="min-width: 50px"
                @change="onChangeItem(item)">
                <a-select-option value="%">%</a-select-option>
                <a-select-option :value="getDiscountCurrency(item.input_currency_id)">
                  {{ getDiscountCurrency(item.input_currency_id) }}
                </a-select-option>
              </a-select>
            </td>
            <td style="min-width: 130px;">
              <input v-if="item.incentive_type == '%'" ref="incentiveRate" type="number"
                v-model.number="item.input_incentive_rate" class="form-control" @change="onChangeItem(item)" />
              <ts-currency-converter-input v-else :input_amount.sync="item.input_incentive_rate"
                :amount.sync="item.incentive_rate" :input_currency_id.sync="item.input_currency_id"
                :currency_id.sync="item.currency_id" :fx_rate.sync="item.fx_rate"
                :fx_rate_ratio.sync="item.fx_rate_ratio" style="min-width: 120px;" />
            </td>
            <td style="min-width: 120px;max-width: 150px;">
              <a-select v-model="item.vendor_customer_id" :options="customers" show-search option-filter-prop="children"
                class="ts-w-full" :class="{ 'is-invalid': errors.has('service_status') }" placeholder="Select"
                @search="handleSearch"></a-select>
            </td>
            <td class="text-center" style="min-width: 27px;">
              <a href="#" class="ts-text-red-700 hover:ts-text-red-700" @click.prevent="removeItem(index)">
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- show product list pop-up -->
    <a-modal v-if="show_form" v-model="show_form" :title="$t('promotion.buyProduct')" :maskClosable="false"
      :footer="null">
      <ProductList v-model="model" />
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ProductList from './product-list.vue'
import { debounce } from 'lodash'
export default {
  name: 'invcentiveByAmountCondition',
  props: ['value', 'validate'],
  components: {
    ProductList,
  },
  data() {
    return {
      errors: new Errors(),
      show_form: false,
      model: {},
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('promotion/incentiveByAmount', ['formViewDatas']),
    productGroups() {
      if (this.formViewDatas['productGroups']) {
        return this.formViewDatas['productGroups']
          .map(el => ({
            value: el.pro_group_id,
            label: el.pro_group_name_en
          }))
      }
      return []
    },
    incentiveProducts() {
      if (this.formViewDatas['incentiveProducts']) {
        return this.formViewDatas['incentiveProducts'].map(el => ({
          value: el.product_id,
          label: el.product_name_en
        }))
      }
      return []
    },
    customers() {
      if (this.formViewDatas['customers']) {
        return this.formViewDatas['customers'].map(el => ({
          value: el.customer_id,
          label: el.customer_name
        }))
      }
      return []
    },
  },
  methods: {
    ...mapActions('promotion/incentiveByAmount', ['getFormViewModel']),
    handleSearch: debounce(async function (value) {
      this.loading = true
      await this.getFormViewModel({
        index: 'customers',
        params: {
          fnName: 'customers',
          search_customer: value,
          customer_id: this.model.condition.map(el => el.vendor_customer_id)
        }
      })
      this.loading = false
    }, 800),
    addItem() {
      this.show_form = true
    },
    removeItem(index) {
      const item = this.model.condition[index]
      if (item.product_id) {
        this.formViewDatas['products'].find(el => el.product_id == item.product_id)._selected = false
      } else {
        this.formViewDatas['productGroups'].find(el => el.product_group_id == item.product_group_id)._selected = false
      }

      this.model.condition.splice(index, 1)
    },
    getDiscountCurrency(input_currency_id) {
      if (this.formViewDatas['currency']) {
        return this.formViewDatas['currency'].find(
          el => el.currency_id == input_currency_id
        ).currency_symbol
      }
      return null
    },
    getProductGroup(pro_group_id) {
      if (this.formViewDatas['productGroups']) {
        return this.formViewDatas['productGroups'].find(el => el.pro_group_id == pro_group_id)
      }
    },
    getProduct(product_id) {
      if (this.formViewDatas['products']) {
        return this.formViewDatas['products'].find(el => el.product_id == product_id)
      }
    },
    operatorChange(row) {
      if (row.operator_sign != 'between') {
        row.amount_to = null
        row.input_amount_to = null
      }
    },
    onChangeItem(product) {
      if (product.discount_type == '%') {
        product.discount_rate = product.input_discount_rate
      } else {
        product.discount_type = this.getDiscountCurrency(product.input_currency_id)
        product.discount_rate = product.input_discount_rate * product.fx_rate_ratio
      }

      if (product.incentive_type == '%') {
        product.incentive_rate = product.input_incentive_rate
      } else {
        product.incentive_type = this.getDiscountCurrency(product.input_currency_id)
        product.incentive_rate = product.input_incentive_rate * product.fx_rate_ratio
      }
    },
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>
<style>
.ant-modal-wrap {
  z-index: 1020 !important;
}

.ant-modal {
  width: 80% !important;
}
</style>